import { api } from '@/lib/api';

function dataUrlToBlob(dataUrl) {
  const [head, b64] = dataUrl.split(',');
  const mime = head.match(/data:(.*?)[;,]/)?.[1] || 'image/jpeg';
  const bin = atob(b64);
  const bytes = new Uint8Array(bin.length);
  for (let i = 0; i < bin.length; i += 1) bytes[i] = bin.charCodeAt(i);
  return new Blob([bytes], { type: mime });
}

// Uploads a data-URL image to the Emergent Object Store and returns its served URL.
// Non-data-URL inputs (already-hosted URLs, null) pass through unchanged.
export async function uploadImage(image) {
  if (!image || !image.startsWith('data:')) return image;
  const blob = dataUrlToBlob(image);
  const ext = (blob.type.split('/')[1] || 'jpg').replace('jpeg', 'jpg');
  const form = new FormData();
  form.append('file', blob, `image.${ext}`);
  const { data } = await api.post('/media/upload', form, { timeout: 60000 });
  return data.url;
}
